import type { ApiErrorBody, ApiErrorCode } from '@debtbot/shared';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: ApiErrorCode,
    message: string,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  static fromBody(status: number, body: unknown): ApiError {
    const err = (body as Partial<ApiErrorBody> | null)?.error;
    if (err && typeof err.code === 'string') {
      return new ApiError(status, err.code, err.message ?? err.code, err.details);
    }
    return new ApiError(status, 'INTERNAL_ERROR', `HTTP ${status}`);
  }
}

/** Mini App открыт из прежнего бота после переезда (API.md §1.1, 410). */
export function isBotMoved(err: unknown): boolean {
  return err instanceof ApiError && err.code === 'BOT_MOVED';
}

export class NetworkError extends Error {
  constructor() {
    super('network');
    this.name = 'NetworkError';
  }
}
